import type { TireHotelDetailTab } from './adminRouteParams';
import { defineRoutes } from './types';
import { getUrlWithQueryParams } from './utils';

type StringOrNumber = string | number;

export type AdminTireHotelPathConfig = {
  tireHotelDetail: { id: StringOrNumber; tab?: TireHotelDetailTab };
};

export const adminTireHotelAppRoutes = defineRoutes<AdminTireHotelPathConfig>()({
  tireHotels: {
    getPath: () => `/tire-hotels`,
    getBasePath: () => '/tire-hotels'
  },
  tireHotelDetail: {
    getPath: ({ id, ...rest }) =>
      getUrlWithQueryParams({
        path: `/tire-hotels/${id}`,
        queryParams: rest
      }),
    getBasePath: () => '/tire-hotels/:id'
  }
});
